import { render, staticRenderFns } from "./baohuoPrivacy.vue?vue&type=template&id=3c076091&scoped=true&"
import script from "./baohuoPrivacy.vue?vue&type=script&lang=js&"
export * from "./baohuoPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./baohuoPrivacy.vue?vue&type=style&index=0&id=3c076091&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c076091",
  null
  
)

export default component.exports